import * as RA from 'ramda-adjunct';
import * as moment from 'moment-timezone';
import {ChangeSet} from '@emm/core/models/change-set.model';

export function compareDayToNow(date: string): number {
    const now = new Date();
    const selectedDate = new Date(date);
    now.setHours(0, 0, 0, 0);
    selectedDate.setHours(0, 0, 0, 0);
    return selectedDate.getTime() - now.getTime();
}

export function isToday(date: string): boolean {
    return compareDayToNow(date) === 0;
}

export function isFutureDate(date: string): boolean {
    return compareDayToNow(date) > 0;
}

export function formatDateToMidnight(effectiveDate: string) {
    // e.g. 2019-08-24T00:00:00.000
    const date = new Date(effectiveDate);
    date.setUTCHours(0, 0, 0, 0); // set time at midnight of selected day
    return date.toISOString().slice(0, -1); // remove Z at end
}


export function formatDateJustBeforeMidnight(effectiveDate: string) {
    // e.g. 2019-08-24T23:59:00.000
    const date = new Date(effectiveDate);
    date.setUTCHours(23, 59, 0, 0); // set time at midnight of selected day
    return date.toISOString().slice(0, -1); // remove Z at end
}


export function getHighlightDate(changeSets: ChangeSet[], d: Date) {
    // convert calendar date to midnight UTC
    const calendarDate = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    let match: ChangeSet;
    if (RA.isNotNil(changeSets)) {
        match = changeSets.filter((changeSet) => {
            // this source date is based on LocalDateTime which has no timezone context
            // however, need to do this to support both legacy (midnight utc) and mbotf (midnight eastern)
            const dateSource = changeSet.effectiveDateLegacy ? changeSet.effectiveDateLegacy : changeSet.effectiveDate;

            // for legacy, add utc timezone (Z) to change set date that are already in midnight utc
            // for mbotf, this is misleading because the actual date is in midnight eastern not utc
            //   however, need to do this to be able to match calendar dates that are currently utc
            const date = dateSource + 'Z';
            const changeSetDate = new Date(date);
            return calendarDate.getTime() === changeSetDate.getTime();
        })[0];
    }
    return match ? 'highlight-date' : undefined;
}

export function isEqual(date1: Date, date2: Date) {
    return date1.getTime() === date2.getTime();
}

export function today() {
    const now = new Date();
    now.setHours(0, 0, 0, 0); // client timezone
    return now;
}

export function formatDateToDefaultTimezone(effectiveDate: string) {
    return moment(effectiveDate).tz(US_EASTERN).format(fullDateTimezoneFormat);
}

export const dateFormat = 'MM-dd-y';
export const timeFormat = 'hh:mm:ss a';
export const dateTimeFormat = `${dateFormat} ${timeFormat}`;

export const US_EASTERN = 'America/New_York';
export const fullDateTimezoneFormat = 'dddd, MMMM DD, YYYY, h:mm a zz'; // momentjs format

export const MenuDateUtil = {
    dateFormat,
    dateTimeFormat,
    getHighlightDate,
    formatDateToMidnight,
    formatDateJustBeforeMidnight,
    isFutureDate,
    isToday,
    timeFormat,
    today,
    formatDateToDefaultTimezone,
    isEqual
};
